import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    RBF0404E40: {
      //수표거래내역조회 결과
      classifyInq: "1",
      acno: "",
      detailValue: {}, //계좌번호 상세정보
      startYmd: "",
      endYmd: "",
      chekNo: "",
      cacInqList: {},
    },
  };
};

const cacInq = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default cacInq;
